var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "py-4"
  }, [_vm.showLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : !_vm.showLoading && _vm.coupons.length > 0 ? _vm._l(_vm.filteredCoupons[_vm.filter], function (item) {
    return _c('coupon-card', {
      key: item.id,
      staticClass: "t-4",
      attrs: {
        "coupon": item,
        "buttonText": item.status == 'applied_and_not_yet' ? '尚未開始' : '查看'
      },
      on: {
        "exchange": _vm.showCouponModal
      }
    });
  }) : _c('coupon-empty')], 2), _c('coupon-modal', {
    ref: "couponModal",
    attrs: {
      "coupon": _vm.selectedCoupon
    },
    on: {
      "confirmed": _vm.refresh
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }